import React, { Component } from 'react';
import { getFormNames, isDirty } from 'redux-form'

import { I18n } from 'react-i18nify-lite';
import { Prompt } from 'react-router-dom';
import { connect } from 'react-redux'

class Wrapper extends Component {
    render() {
        return (
            <Prompt
                when={this.props.when}
                message={I18n.t('form.dirtyFormNavigation')}
                {...this.props}
            />
        )
    }
}

const protectedFormNames = [
    'hostGroupForm',
];

const mapStateToProps = (state, ownProps) => {
    const formNames = getFormNames()(state).filter( name => protectedFormNames.includes(name));
    const dirtyList = formNames.map( name => isDirty(name)(state));    
    return { 
        when:dirtyList.some(val => val),
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)